import { Link } from 'react-router-dom';

// Logo image URL
const LOGO_URL = 'https://customer-assets.emergentagent.com/job_2213c46e-8f75-400c-a9dc-a18448f4cb8f/artifacts/58sqz7v5_751D9D59-75EB-4449-A2D7-D7A03FA0140A.png';

export const Logo = ({ size = 'default', showText = false, variant = 'horizontal', className = '' }) => {
  const sizes = {
    small: { height: 80 },
    default: { height: 110 },
    large: { height: 140 },
    hero: { height: 180 },
  };

  const { height } = sizes[size] || sizes.default;

  return (
    <Link to="/" className={`flex items-center group ${className}`} data-testid="logo-link">
      <img
        src={LOGO_URL}
        alt="LinkTheMissing - Connecting the Unidentified"
        style={{ height: `${height}px`, width: 'auto' }}
        className="group-hover:opacity-90 transition-opacity object-contain"
      />
    </Link>
  );
};

// Standalone icon for use in other places (uses just the icon part)
export const LogoIcon = ({ size = 40, className = '' }) => (
  <img
    src={LOGO_URL}
    alt="LinkTheMissing"
    style={{ height: `${size}px`, width: 'auto' }}
    className={`object-contain ${className}`}
  />
);

// Larger logo variant for hero sections and email templates
export const LogoFull = ({ className = '' }) => (
  <div className={`flex items-center ${className}`}>
    <img
      src={LOGO_URL}
      alt="LinkTheMissing - Connecting the Unidentified"
      style={{ height: '80px', width: 'auto' }}
      className="object-contain"
    />
  </div>
);
